import React from "react";
import AssetsIcon from "../../assets/icons/asset-01.svg2";
import PageHeader from "../Common/PageHeader";
import WidgetContainer from "../Common/WidgetContainer";
import AssetsLinks from "./AssetsLinks";

const defaultWidgetLayout = [
  { i: "./ContactsAndAssetsMapWidget.jsx", x: 0, y: 0, w: 5, h: 10 },
  { i: "./AssetsWidget.jsx", x: 5, y: 0, w: 5, h: 10 },
  // { i: "./AssetsWidget.jsx", x: 10, y: 0, w: 5, h: 10 },
  // { i: "./GroupsWidget.jsx", x: 15, y: 0, w: 5, h: 10 },
  // { i: "./EventsWidget.jsx", x: 0, y: 10, w: 10, h: 10 },
  // { i: "./MonitoringWidget.jsx", x: 10, y: 10, w: 10, h: 10 },
];

export default function AssetsLandingPage() {
  return (
    <div>
      <PageHeader
        Icon={AssetsIcon}
        heading="Assets"
        subheading="Access the asserts used on your Logic system"
      />
      <AssetsLinks />

      <WidgetContainer
        defaultLayout={defaultWidgetLayout}
        lsField="assetsWidgetLayout"
      />
    </div>
  );
}
